import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IntlProvider, addLocaleData, FormattedMessage } from 'react-intl';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router-dom';
import queryString, { parse, stringify } from 'query-string';

import en from 'react-intl/locale-data/en';
import fi from 'react-intl/locale-data/fi';
import sv from 'react-intl/locale-data/sv';

import {
  changeLocale,
  resetLocale,
  onLogin,
  logout,
  onTokenLogin,
} from '~actions'; // eslint-disable-line

// Containers
import Report from './features/report/report.container';
import CompanyReviews from './features/review/company.review.container';
import Dashboard from './features/dashboard/dashboard.container';
import DebugView from './features/common/DebugLinks';
import UserReviews from './features/review/user.review.container';
import Chat from './features/chat/chat.container';

// Components
import { PrivateRoute } from './routes';
import NotFound from './features/common/NotFound';
import LoginDisclaimer from './features/user/LoginDisclaimer';
import Navigation from './features/common/Navigation';

import fiFI from './localisations/fi_FI.json';
import svSE from './localisations/sv_SE.json';
import enGB from './localisations/en_GB.json';
import LoadingIndicator from './components/LoadingIndicator';
import { getApiUrl } from './services/utils';

addLocaleData([...en, ...fi, ...sv]);

const loginRoute = ({ component: RouteComponent, locale, ...rest }) =>
  <Route
    {...rest}
    render={props => {
      const loginParams = { locale };
      if (props.location.search) {
        const extra = parse(props.location.search);
        if (extra.postGluuLoginRedirectUrl) {
          loginParams.postGluuLoginRedirectUrl = extra.postGluuLoginRedirectUrl;
        }
      }
      window.location.href =
        `${getApiUrl()}/authenticate/login?${stringify(loginParams)}`;
      return (
        <div className="main pure-g">
          <div
            className="pure-u-1 no-print"
            style={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <h1>
              <FormattedMessage id="login.checking" />
            </h1>
            <LoadingIndicator iconSize='large' />
          </div>
        </div>
      );
    }}
  />;
loginRoute.propTypes = {
  component: PropTypes.func.isRequired,
  locale: PropTypes.string,
  location: PropTypes.object.isRequired,
};
const LoginRoute =
  connect(state => ({
    locale: state.locale.lang,
  }))(loginRoute);


const propTypes = {
  location: PropTypes.object.isRequired, // Injected by React Router
  match: PropTypes.object.isRequired, // Injected by React Router
  locale: PropTypes.object.isRequired,
  session: PropTypes.object.isRequired,
  onLogin: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  onTokenLogin: PropTypes.func.isRequired,
  changeLocale: PropTypes.func.isRequired,
  history: PropTypes.object,
};

class App extends Component {
  componentWillMount() {
    // Get login token and login with it
    const token = localStorage.getItem('user_token');
    if (token) {
      this.props.onTokenLogin({ token });
    }
    window.mobilecheck = () => {
      let check = false;
      /* eslint-disable */
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      /* eslint-enable */
      return check;
    };
  }

  generateHrefLangTags() {
    const { search, pathname } = this.props.location;
    const { origin } = window.location;
    const query = queryString.parse(search);
    const langs = ['fi', 'sv', 'en'];

    let hostBase = `${origin}${pathname}?`;
    hostBase += Object.keys(query).reduce((params, key) => {
      if (key !== 'lang') params.push(`${key}=${query[key]}`);
      return params;
    }, []).join('&');

    return (
      langs.map(lang =>
        <link
          key={`hreflang-${lang}`}
          rel='alternate'
          href={`${hostBase}&lang=${lang}`}
          hrefLang={lang}
        />
      )
    );
  }

  render() {
    const {
      session,
      locale,
      match,
      changeLocale: changeLocaleProp,
      history,
    } = this.props;

    const messages = {
      fi: fiFI,
      sv: svSE,
      en: enGB,
    };

    const navProps = {
      session,
      history,
      locale,
      changeLocale: changeLocaleProp,
      logout: this.props.logout,
      login: this.props.onLogin,
    };

    return (
      <div className='App'>
        <Helmet>
          {this.generateHrefLangTags()}
        </Helmet>
        <IntlProvider locale={locale.lang} messages={messages[locale.lang]}>
          <div>
            <Navigation {...navProps} />
            <Switch>
              <Route exact path={`${match.url}`} component={DebugView} />
              <Route
                path={`${match.url}/user/:userId/reviews`}
                component={UserReviews}
              />
              <Route path={`${match.url}/chat/:chatId`} component={Chat} />
              <Route
                exact
                path={`${match.url}/:country/:identifier`}
                component={Report}
              />
              <Route
                exact
                path={`${match.url}/:country/:identifier/reviews`}
                component={CompanyReviews}
              />
              <PrivateRoute
                exact
                path={`${match.url}/:country/:identifier/dashboard`}
                component={Dashboard}
              />
              <Route
                path={`${match.url}/login-disclaimer`}
                component={LoginDisclaimer}
              />
              <LoginRoute path="/selvitys/login" />
              <Route path="*" component={NotFound} locale={locale} />
            </Switch>
          </div>
        </IntlProvider>
      </div>
    );
  }
}

App.propTypes = propTypes;

// This makes state objects available to the component via props!
function mapStateToProps(state) {
  return {
    locale: state.locale,
    session: state.session,
  };
}

// // This adds action creators to components props
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeLocale,
      resetLocale,
      onLogin,
      logout,
      onTokenLogin,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
